import React from 'react'
import { CheckboxProps, Form, Header, InputOnChangeData, Segment } from 'semantic-ui-react'
import { IProject } from '../../../api/Data'
import CustomLabel from '../../../components/common/custom-label/CustomLabel'

const CollectTabCollectPage = (props: IProps) => {
  // Props
  const { project, handleChange } = props

  const handleCheckboxChange = (e: React.MouseEvent<HTMLInputElement, MouseEvent>, data: CheckboxProps) => {
    const { name, checked } = data

    const newProjectOption = { ...project.displaySetting, [String(name)]: Boolean(checked) }

    handleChange(e, {
      name: 'displaySetting',
      value: { ...newProjectOption },
    })
  }

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>, data: InputOnChangeData) => {
    const { name, value } = data

    const newProjectOption = { ...project.displaySetting, [name]: value }

    handleChange(e, {
      name: 'displaySetting',
      value: { ...newProjectOption },
    })
  }

  const { displaySetting } = project

  console.log('Rendering Contributor Settings Form', project)

  return (
    <>
      <Header as="h1" style={{ marginBottom: '2rem', fontWeight: 'bold' }}>
        Contributor Data Collection
        <Header.Subheader>
          <p>
            Customize the data you want to collect from contributors during video submission—from names and emails, to
            structured tags like location, store number, or category.
          </p>
          <p>
            Use this builder to define the fields that appear in your upload forms. You can mix free-text inputs with
            dropdowns, radio buttons, or multiple-choice selections.
          </p>
        </Header.Subheader>
      </Header>

      <Segment>
        <Header as="h2" style={{ fontWeight: 'bold' }}>
          General Information
          <Header.Subheader>
            <p>
              Gather essential details from your contributors. These fields are collected once per contributor,
              regardless of how many videos they submit.
            </p>
          </Header.Subheader>
        </Header>

        <Form>
          <Form.Field required={false}>
            <CustomLabel>
              <CustomLabel.Text text="Name" />
              <CustomLabel.Popup popupContent="Contributor name is mandatory to ensure clear attribution and valid consent to use their video." />
            </CustomLabel>
          </Form.Field>
          <Form.Field required={false}>
            <CustomLabel>
              <CustomLabel.Text text="IP Address (hidden field)" />
              <CustomLabel.Popup popupContent="We collect each contributor’s IP address alongside their name to create a legally enforceable consent record. This is not shown to contributors." />
            </CustomLabel>
          </Form.Field>
          <Form.Field>
            <CustomLabel>
              <CustomLabel.Text text="Location" />
              <CustomLabel.Popup popupContent="Automatically detected from the mobile device’s metadata. The contributor will be asked to confirm or choose from a list of nearby places." />
              <CustomLabel.Checkbox
                name="showLocation"
                checked={displaySetting.showLocation}
                onClick={handleCheckboxChange}
              />
            </CustomLabel>
          </Form.Field>
        </Form>
      </Segment>
    </>
  )
}

interface IProps {
  project: IProject
  handleChange: (
    arg: React.SyntheticEvent | null,
    { name, value, checked, values }: { name: string; value?: string; checked?: boolean; values?: string[] }
  ) => void
}

export default CollectTabCollectPage
